<template>
    <div class="container"  v-title="'我的等级'">
        <Navigation-bar :class="{'Bokeh':athleteCertificate.show}"></Navigation-bar>
        <div class="container_content" :class="{'Bokeh':athleteCertificate.show}">
            <Title title="我的等级" subtitle="查看运动员等级"></Title>
            <div id="MyAttestationGrade">
                <div class="MAG_scroll">
                    <div class="MAG_content">
                        <div class="regulation">
                            <div class="whole" v-show="regulation" v-href="'/Rules/CertificationRegulation'">
                                <p>「中国职工体育赛事认证体系管理办法」</p>
                                <p>赛事认证·赛事积分·运动员等级评定</p>
                                <p><span>点击进入</span><YD-image src="logo_新"></YD-image></p>
                            </div>
                            <div class="simplify" v-show="!regulation" v-href="'/Rules/CertificationRegulation'">
                                <div>
                                    <span>中国职工体育赛事认证体系管理办法</span><span>点击进入</span>
                                </div>
                            </div>
                        </div>
                        <div class="pattern">
                            <div class="pattern_fixed" :class="{'fixed':isPatternFixed}">
                                <ul>
                                    <li :class="{'active':pattern == 0}" @click="()=>{pattern = 0}">
                                        <YD-image class="img1" src="icon/icon_重叠_黑色"></YD-image>
                                        <YD-image class="img2" src="icon/icon_重叠_白色"></YD-image>
                                    </li>
                                    <li :class="{'active':pattern == 1}" @click="()=>{pattern = 1}">
                                        <YD-image class="img1" src="icon/icon_排列_黑色"></YD-image>
                                        <YD-image class="img2" src="icon/icon_排列_白色"></YD-image>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="certificate_list">
                            <ul class="cards" v-show="pattern == 0 && list.length > 0">
                                <li v-for="(item,index) in list" :key="index" @click="cardClick(index, item)">
                                    <YD-image class="medal" :src="'athlete_certificate/奖章'+item.AthleteLevel+'级'" ></YD-image>
                                    <YD-image class="grade" :src="'athlete_certificate/职工'+item.AthleteLevel+'级'" ></YD-image>
                                    <ul class="info">
                                        <li>{{item.AthleteName}}</li>
                                        <li>{{item.AthleteGender==2?'女':'男'}}</li>
                                        <li>{{item.AthleteMemberNo}}</li>
                                        <li>{{item.EventsName}}</li>
                                        <li>{{item.SubLeagueName + item.LeagueGroupName + item.MatchScore}}</li>
                                    </ul>
                                    <div class="certificate_serialNumber">证书编号：{{item.CertificateNumber}}</div>
                                    <div class="certificate_date">{{item.CertificateTime | dateFormat('yyyy年MM月dd日')}}</div>
                                    <div class="stamp"></div>
                                </li>
                            </ul>
                            <ul class="arrange" v-show="pattern == 1 && list.length > 0">
                                <li v-for="(item,index) in list" :key="index" @click="lookOverCertificate(item)">
                                    <p class="medal"><YD-image :src="`athlete_certificate/list/奖章${item.AthleteLevel}级`"></YD-image></p>
                                    <p class="project_description">{{setProjectText(item.EventsName).desc}}</p>
                                    <p class="project">#{{setProjectText(item.EventsName).name}}</p>
                                    <p class="text">{{item.SubLeagueName + item.LeagueGroupName + item.MatchScore}}</p>
                                    <YD-image class="grade" :src="`athlete_certificate/职工${item.AthleteLevel}级`"></YD-image>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="athlete_certificate" v-show="athleteCertificate.show"  ref="athlete_certificate">
            <div class="certificate_modal share">
                <YD-image class="certificate_close" src="icon/icon_close" @click.native="athleteCertificate.show = false"></YD-image>
                <div class="certificate_content" v-certificateScale>
                    <YD-image class="certificate_medal" :src="'athlete_certificate/奖章'+athleteCertificate.AthleteLevel+'级'" ></YD-image>
                    <YD-image class="certificate_grade" :src="'athlete_certificate/职工'+athleteCertificate.AthleteLevel+'级'" ></YD-image>
                    <ul class="certificate_info">
                        <li>{{athleteCertificate.AthleteName}}</li>
                        <li>{{athleteCertificate.AthleteGender==2?'女':'男'}}</li>
                        <li>{{athleteCertificate.AthleteMemberNo}}</li>
                        <li>{{athleteCertificate.EventsName}}</li>
                        <li>{{athleteCertificate.SubLeagueName + athleteCertificate.LeagueGroupName + athleteCertificate.MatchScore}}</li>
                    </ul>
                    <div class="certificate_serialNumber">证书编号：{{athleteCertificate.CertificateNumber}}</div>
                    <div class="certificate_date">{{athleteCertificate.CertificateTime | dateFormat('yyyy年MM月dd日')}}</div>
                    <div class="certificate_stamp"></div>
                </div>
                <!-- 低版本兼容-->
                <template v-if="$appVersion < '22093000'">
                    <p>请拨打电话4006240066联系客服邮寄证书</p>
                    <button class="certificate_share" @click="download()">保存</button>
                </template>
                <template v-else>
                    <p><span @click="makingCalls">拨打电话</span>联系客服邮寄证书</p>
                    <button class="certificate_share" @click="share">分享</button>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import {
    GetMyAthleteLevelCertificateList,
    GetAthleteLevelCertificateFile,//获取运动员等级证书下载信息（单个）
} from "@/api"
import { 
    saveImage,
    share,
    makingCalls
} from "@js/appInteraction"
import {
    convertSize
} from '@js';
export default {
    name:"MyAttestationGrade",
    data(){
        return {
            regulation: true,//管理方法显示样式
            roll: 0,//滚动距离
            list:[],
            pattern:0,
            cardCurrentIndex:0,
            isPatternFixed:false,
            athleteCertificate:{},//运动员证书显示
        }
    },
    created(){
        GetMyAthleteLevelCertificateList().then(data=>{
            if(data.Code == 0){
                this.list = data.ContinuedList;
                this.$nextTick(function(){
                    this.initCard();
                    this.setPatternStyle(0);
                })
            }
        })
    },
    mounted(){
        var _this = this;
        $('#MyAttestationGrade .MAG_scroll').scroll(function () {
            var scroll = $('#MyAttestationGrade .MAG_scroll').scrollTop();
            _this.roll = scroll;
        });
        var h = document.body.offsetHeight;
        if(convertSize(13.4) > h){
            this.$refs['athlete_certificate'].style.alignItems = "normal";
        }
    },
    watch:{
        roll:function(scroll){
            $('#MyAttestationGrade .MAG_scroll').scrollTop(this.roll);
            var h = $('#MyAttestationGrade .MAG_scroll').innerHeight(),
                cH = $('#MyAttestationGrade .MAG_content').height(),
                wholeH =  $('#MyAttestationGrade .regulation').height(),
                simplifyH = $('#MyAttestationGrade .regulation .simplify').height();
            //管理办法
            if(scroll > wholeH - simplifyH){
                this.regulation = false;
                this.isPatternFixed = true;
            }else{
                this.regulation = true;
                this.isPatternFixed = false;
            }
        },
        pattern:function(val){
            this.$nextTick(function(){
                this.setPatternStyle(val);
            })
        }
    },
    methods:{
        setProjectText(text){
            var desc = '',name = '';
            if(text.indexOf('足球') > -1){
                desc = '(' + text.replace('足球','') + ')';
                name = '足球';
            }else if(text.indexOf('篮球') > -1){
                desc = '(' + text.replace('篮球','') + ')';
                name = '篮球';
            }else{
                desc = '';
                name = text;
            }
            return {desc,name};
        },
        cardClick(index, obj){
            if(index == this.cardCurrentIndex){
                this.lookOverCertificate(obj);
            }
        },
        lookOverCertificate(obj){
            this.athleteCertificate = {
                show: true,
                ...obj
            }
        },
        download(){
            GetAthleteLevelCertificateFile({
                CertificateNumber: this.athleteCertificate.CertificateNumber
            }).then(data=>{
                if(data.Code == 0){
                    saveImage(data.CertificateFile);
                }
            })
        },
        //分享
        share(){
            GetAthleteLevelCertificateFile({
                CertificateNumber: this.athleteCertificate.CertificateNumber
            }).then(data=>{
                if(data.Code == 0){
                    share({
                        Type: 7,
                        Title: "",
                        Text: "",
                        Link: "https://m.dazhongyundong.com/app_download/",
                        LinkText: "立即下载APP：",
                        ImgLink: data.CertificateFile
                    });
                }
            })
        },
        //拨打电话
        makingCalls(){
            makingCalls('4006240066');
        },
        setPatternStyle(val){
            if(val==0){
                $('#MyAttestationGrade .MAG_scroll').css('overflow','hidden');
                var h = $('#MyAttestationGrade .MAG_scroll').innerHeight(),
                    cH = $('#MyAttestationGrade .MAG_content').height(),
                    wholeH =  $('#MyAttestationGrade .regulation').height(),
                    simplifyH = $('#MyAttestationGrade .regulation .simplify').height();
                if(cH > h){
                    if(cH - h < wholeH - simplifyH){
                        let num = (wholeH - simplifyH) - (cH - h);
                        $('#MyAttestationGrade .MAG_content').css('padding-bottom',num+1+'px');
                    }
                    this.roll = wholeH - simplifyH + 1;
                }
            }else{
                $('#MyAttestationGrade .MAG_scroll').css('overflow-y','auto');
                $('#MyAttestationGrade .MAG_content').css('padding-bottom','0px');
            }
        },
        initCard(){
            var _this = this;
            var doms = $('.cards>li'),//dom
                currentIndex = 0,//下标
                length = doms.length,//总长度
                bisection = parseInt(length / 2);//分割到两边的数量
            var loop = length >= 5;
            currentIndex = loop >= 3 ? 1 : 0;
            this.cardCurrentIndex = currentIndex;
            this.setCardLocate({
                doms,
                length,
                bisection,
                currentIndex,
                loop
            });
            $('.cards').on('touchstart',function(ev){
                var e = ev || event;
                var X = e.touches[0].clientX;
                var w = $(window).width();
                var rate = 0,//运动比例
                    isLeftMove=true;//移动方向
                window.ontouchmove=function(ev){
                    e = ev || event;
                    var X1 = e.touches[0].clientX;
                    if(X < w/4*3 && X1 > X ){//向右
                        isLeftMove = false;
                        rate = (X1 - X) / 300;
                        if(rate>1)rate=1;
                        $.each(doms,(index,item)=>{
                            $(item).css('transition','none');
                            if(index == currentIndex){
                                $(item).css({
                                    transform: `scale(${1 - ( 0.19 * rate)}) translate(${1.7*rate}rem,${0.25*rate}rem)`,
                                    zIndex: 30 - parseInt(5*rate)
                                })
                            }else{
                                let isLeft = true,
                                    num = 0;
                                if(index < currentIndex) {
                                    if(!loop || index >= currentIndex - bisection){//添加到左边
                                        num = currentIndex - index;
                                        isLeft = true;
                                    }else{//添加到右边
                                        num = index + length - currentIndex;
                                        isLeft = false;
                                    }
                                }else if(index > currentIndex) {
                                    if(!loop || index <= currentIndex + bisection){//添加到右边
                                        num = index - currentIndex;
                                        isLeft = false;
                                    }else{//添加到左边
                                        num = currentIndex - (index - length);
                                        isLeft = true;
                                    }
                                }
                                if(isLeft){
                                    if(num == 1){
                                        $(item).css({
                                            transform: `scale(${0.81 + (0.2*rate)}) translate(-${1.7*(1-rate)}rem, ${0.25*(1-rate)}rem)`,
                                            zIndex: 25 + parseInt(5*rate)
                                        })
                                    }else{
                                        let scale = 0.81 - ((num - 1) / 10);
                                            scale = scale < 0.4 ? 0.4 : scale;
                                        $(item).css({
                                            transform: `scale(${scale + (0.1 * rate)}) translate(-1.7rem, 0.25rem)`,
                                            zIndex: 25 - num
                                        })
                                    }
                                }else{
                                    let scale = 0.81 - ((num - 1) / 10);
                                        scale = scale < 0.4 ? 0.4 : scale;
                                    $(item).css({
                                        transform: `scale(${scale - (0.1 * rate)}) translate(1.7rem, 0.25rem)`,
                                        zIndex: 25 - num
                                    })
                                }
                            }
                        })
                    }else if(X > w/4*1 && X1 < X){//向左
                        isLeftMove = true;
                        rate = (X - X1) / 300;
                        if(rate>1)rate=1;
                        $.each(doms,(index,item)=>{
                            $(item).css('transition','none');
                            if(index == currentIndex){
                                $(item).css({
                                    transform: `scale(${1 - ( 0.19 * rate)}) translate(-${1.7*rate}rem,${0.25*rate}rem)`,
                                    zIndex: 30 - parseInt(5*rate)
                                })
                            }else{
                                let isLeft = true,
                                    num = 0;
                                if(index < currentIndex) {
                                    if(!loop || index >= currentIndex - bisection){//添加到左边
                                        num = currentIndex - index;
                                        isLeft = true;
                                    }else{//添加到右边
                                        num = index + length - currentIndex;
                                        isLeft = false;
                                    }
                                }else if(index > currentIndex) {
                                    if(!loop || index <= currentIndex + bisection){//添加到右边
                                        num = index - currentIndex;
                                        isLeft = false;
                                    }else{//添加到左边
                                        num = currentIndex - (index - length);
                                        isLeft = true;
                                    }
                                }
                                if(isLeft){
                                    let scale = 0.81 - ((num - 1) / 10);
                                        scale = scale < 0.4 ? 0.4 : scale;
                                    $(item).css({
                                        transform: `scale(${scale - (0.1 * rate)}) translate(-1.7rem, 0.25rem)`,
                                        zIndex: 25 - num
                                    })
                                }else{
                                    if(num == 1){
                                        $(item).css({
                                            transform: `scale(${0.81 + (0.2 * rate)}) translate(${1.7*(1-rate)}rem, ${0.25*(1-rate)}rem)`,
                                            zIndex: 25 + parseInt(5*rate)
                                        })
                                    }else{
                                        let scale = 0.81 - ((num - 1) / 10);
                                            scale = scale < 0.4 ? 0.4 : scale;
                                        $(item).css({
                                            transform: `scale(${scale + (0.1 * rate)}) translate(1.7rem, 0.25rem)`,
                                            zIndex: 25 - num 
                                        })
                                    }
                                }
                            }
                        })
                    }
                }
                window.ontouchend=function(){
                    window.ontouchmove = window.ontouchend = null;
                    if(rate > 0.5){
                        if(isLeftMove){
                            currentIndex++;
                            if(currentIndex > length-1 && loop) currentIndex = 0;
                            if(currentIndex > length-1 && !loop) currentIndex = length -1;
                        }else{
                            currentIndex--;
                            if(currentIndex < 0 && loop) currentIndex = length-1;
                            if(currentIndex < 0 && !loop) currentIndex = 0;
                        }
                    }
                    _this.setCardLocate({
                        doms,
                        length,
                        bisection,
                        currentIndex,
                        loop,
                        rate
                    });
                }
            })
        },
        setCardLocate(obj){
            var {
                    doms,
                    length,
                    bisection,
                    currentIndex,
                    loop,
                    rate: rate = 1
                } = obj;
            this.cardCurrentIndex = currentIndex;
            $.each(doms,(index,item)=>{
                $(item).css('transition',(rate<0.5?(1-rate)*0.5:rate*0.5)+'s');
                if(index == currentIndex){
                    $(item).css({
                        transform: `scale(1) translate(0rem,0rem)`,
                        zIndex: 30
                    })
                }else{
                    let isLeft = true,
                        num = 0;
                    if(index < currentIndex) {
                        if(!loop || index >= currentIndex - bisection){//添加到左边
                            num = currentIndex - index;
                            isLeft = true;
                        }else{//添加到右边
                            num = index + length - currentIndex;
                            isLeft = false;
                        }
                    }else if(index > currentIndex) {
                        if(!loop || index <= currentIndex + bisection){//添加到右边
                            num = index - currentIndex;
                            isLeft = false;
                        }else{//添加到左边
                            num = currentIndex - (index - length);
                            isLeft = true;
                        }
                    }
                    if(isLeft){
                        let scale = 0.81 - ((num - 1) / 10);
                        scale = scale < 0.4 ? 0.4 : scale;
                        $(item).css({
                            transform: `scale(${scale}) translate(-1.7rem, 0.25rem)`,
                            zIndex: 25 - num
                        })
                    }else{
                        let scale = 0.81 - ((num - 1) / 10);
                        scale = scale < 0.4 ? 0.4 : scale;
                        $(item).css({
                            transform: `scale(${scale}) translate(1.7rem, 0.25rem)`,
                            zIndex: 25 - num
                        })
                    }
                } 
            })
        }
    }
}
</script>
<style lang="scss" scoped>
#MyAttestationGrade{
    
    position: relative;
    overflow: hidden;
    .MAG_scroll{
        height: 100%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        .MAG_content{
            width: 100%;
            height: auto;
        }
    }
    @include regulation;
    .pattern{
        width: 100%;
        height: 176px;
        box-sizing: border-box;
        .pattern_fixed{
            height: 176px;
            width: 100%;
            background: #ffffff;
            padding-top: 64px;
            padding-bottom: 40px;
            box-sizing: border-box; 
            &.fixed{
                position: absolute;
                left: 0;
                top: 64px;
                z-index: 1;
            }
            ul{
                display: flex;
                width: 320px;
                height: 72px;
                background: #FFFFFF;
                box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.3);
                border-radius: 20px;
                margin: 0 auto;
                li{
                    flex: 1;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    &.active{
                        background: #1B1C1E;
                        border-radius: 20px;
                    }
                    img{
                        width: 32px;
                        height: 32px;
                    }
                    .img1,
                    &.active .img2{
                        display: block;
                    }
                    .img2,
                    &.active .img1{
                        display: none;
                    }
                }
            }
        }
    }
    .certificate_list{
        height: 740px;
        width: 100%;
        padding: 0 40px;
        box-sizing: border-box;
        ul.cards{
            width: 100%;
            height: 100%;
            position: relative;
            >li{
                width: 488px !important;
                height: 708px !important;
                box-shadow: 0px 8px 36px 0px rgba(136,136,136,0.31);
                position: absolute;
                top: 0;
                left: 91px;
                @include bg-image('~@images/athlete_certificate/模版');
                background-repeat:no-repeat ;
                background-size: 100% 100%;
                >*{
                    position: absolute;
                }
                .medal{
                    width: 260px;
                    height: 260px;
                    top: 0px;
                    left: 112px;
                }
                .grade{
                    width: 117px;
                    height: 38px;
                    top: 240px;
                    left: 184px;
                }
                .info{
                    width: 207px;
                    top: 305px;
                    left: 192px;
                    li{
                        width: 100%;
                        font-size: 14px;
                        color: #231815;
                        letter-spacing: 0.58px;
                        line-height: 18px;
                        font-weight: 500;
                        word-wrap: break-word;
                        margin-bottom: 18px;
                    }
                }
                .certificate_serialNumber{
                    width: 100%;
                    font-size: 14px;
                    letter-spacing: 2.02px;
                    color: #231815;
                    text-align: center;
                    line-height: 14px;
                    font-weight: 400;
                    top: 527px;
                    left: 0;
                }
                .certificate_date{
                    font-size: 14px;
                    color: #636A6F;
                    letter-spacing: 0.7px;
                    font-weight: 400;
                    line-height: 14px;
                    top: 599px;
                    left: 308px;
                }
                .stamp{
                    width: 131px;
                    height: 131px;
                    top: 525px;
                    left: 297px;
                    @include bg-image('~@images/athlete_certificate/盖章');
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
            }
        }
        .arrange{
            width: 100%;
            box-sizing: border-box;
            padding-bottom: 40px;
            li{
                display: inline-block;
                width: 326px;
                height: 288px;
                padding-left: 32px;
                padding-top: 46px;
                box-sizing: border-box;
                margin-bottom: 24px;
                margin-right: 18px;
                box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
                border-radius: 20px;
                position: relative;
                &:nth-of-type(2n){
                    margin-right: 0px;
                }
                .medal{
                    img{
                        height: 194px;
                        width: 194px;
                        position: absolute;
                        top: 0;
                        right: 0;
                    }
                }
                .project_description{
                    height: 28px;
                    font-size: 20px;
                    color: #545A65;
                    font-weight: 500;
                    line-height: 28px;
                    margin-bottom: 2px;
                }
                .project{
                    font-size: 32px;
                    color: #1B1C1E;
                    font-weight: 500;
                    line-height: 44px;
                }
                .text{
                    height: 56px;
                    width: 250px;
                    font-size: 20px;
                    color: #545A65;
                    font-weight: 400;
                    line-height: 28px;
                    margin-top: 32px;
                    overflow: hidden;
                    -webkit-line-clamp: 2;
                    text-overflow: ellipsis;
                }
                .grade{
                    width: 160px;
                    height: 52px;
                    margin-top: 8px;
                    margin-left: -10px;
                }
            }
        }
    }
}
@include athlete_certificate;
#athlete_certificate{
    z-index: 50;
}
</style>